import { Box, Divider, Stack } from "@mui/material";
import { useTranslation } from "next-i18next";
import { Typography } from "src/components-mui/base/typography/typography";
import { SelectionPickerChips } from "src/components-mui/common/modal/adjust-figures-preferences-modal/selection-picker/selection-picker-chips";
import type { IFiguresSectionProps } from "./figures-section.types";

export const FiguresSection = ({ picker, figureSections, pt, description }: IFiguresSectionProps) => {
    const { t } = useTranslation("adjust-preferences-modal");

    const descriptionText = description || t("description.selecting");

    return (
        <Box
            sx={{
                pt: pt,
            }}
        >
            <Typography
                component="h2"
                sx={{
                    fontSize: "xl",
                    fontWeight: "bold",
                }}
            >
                {t("subheadline.select")} ({picker.selected.length}/{picker.maxSelectable})
            </Typography>
            <Typography
                sx={{
                    fontSize: "sm",
                    py: 2,
                }}
            >
                {descriptionText}
            </Typography>

            <Stack
                sx={{
                    gap: 0,
                }}
            >
                {figureSections.map((section, index) => (
                    <Box key={section.label + index}>
                        <Stack
                            direction={{ xs: "column", sm: "row" }}
                            sx={{
                                gap: 2,
                                width: "100%",
                                py: 2,
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                            }}
                        >
                            <Typography
                                sx={{
                                    py: 0.5,
                                    width: { xs: "100%", sm: "auto" },
                                    fontSize: "md",
                                    fontWeight: "bold",
                                    minWidth: "fit-content",
                                }}
                            >
                                {section.label}
                            </Typography>
                            <SelectionPickerChips
                                picker={picker}
                                items={section.data}
                                getLabel={figure => figure.label}
                                sx={{ justifyContent: { xs: "flex-start", sm: "flex-end" } }}
                            />
                        </Stack>
                        <Divider sx={{ borderColor: "gray.100" }} />
                    </Box>
                ))}
            </Stack>
        </Box>
    );
};
